import {
  ChatChannelListItem,
  ChatChannelUser,
  ChatMessageItem,
  EditChatMessageItem,
  MessageType,
} from 'types/chat.types';
import { ProfileCard } from 'types/profile';
import { ChatState } from 'app/store/Chat/slice';

export const formatMessageContent = (
  messageDetails: ChatMessageItem,
  user?: ProfileCard
): MessageType => {
  return {
    guid: messageDetails.guid,
    created: messageDetails.created,
    createdBy: messageDetails.createdBy,
    updated: messageDetails.updated,
    text: messageDetails.text,
    _links: messageDetails._links,
    deleted: messageDetails.deleted,
    needRetry: false,
    user,
  };
};

export const updateMessage = (
  messages: MessageType[],
  message: EditChatMessageItem
): MessageType[] =>
  messages.map((el) => (el.guid === message.guid ? { ...el, ...message } : el));

export const toChannelMessageData: (
  message: ChatMessageItem,
  state: ChatState
) => ChatChannelListItem['latestMessage'] = (message, state) => {
  const userCard = state.currentChannel?.channelUsers.find(
    (user: ChatChannelUser) => user.userGuid === message.createdBy.userGuid
  );
  return {
    guid: message.guid,
    type: message.type,
    text: message.text,
    updated: message.updated,
    createdBy: {
      userGuid: message.createdBy.userGuid,
      profileCard: userCard?.profileCard,
    },
  };
};
